import MarketplaceV2 from '@/components/v2/common/Marketplace';

const CollectionMarketplace = () => (
  <section className="bg-white">
    <MarketplaceV2 />
  </section>
);

export default CollectionMarketplace;
